// ================== SALES PROPOSAL REDUX REDUCER ================== //

const initialState = {
  salesProposalData: { attachments: [] },
  currentViewTab: "New",
  refreshComments: true,
  mainStatusTab: "New",
  refreshFiles: false
};

export const SalesProposalReducer = (state = initialState, action) => {
  switch (action.type) {

    case "SET_SALESPROPOSAL":
      return { ...state, salesProposalData: action.payload };

    case "SET_SALESPROPOSAL_VIEW_TAB":
      return { ...state, currentViewTab: action.payload };

    case "SET_REFRESH_SALESPROPOSAL_COMMENTS":
      return { ...state, refreshComments: action.payload };

    case "SET_REFRESH_SALESPROPOSAL_FILES":
      return { ...state, refreshFiles: action.payload };

    case "RESET_SALESPROPOSAL_STATE":
      return initialState;

    case "SET_MAIN_STATUS_TAB":
      return{...state, mainStatusTab: action.payload };

    default:
      return state;
  }
};


// ================== ACTION CREATORS ================== //

export const setSalesProposal = (data) => ({
  type: "SET_SALESPROPOSAL",
  payload: data
});

export const setSalesProposalViewTab = (tab) => ({
  type: "SET_SALESPROPOSAL_VIEW_TAB",
  payload: tab
});

export const setRefreshSalesProposalComments = (value) => ({
  type: "SET_REFRESH_SALESPROPOSAL_COMMENTS",
  payload: value
});

export const setRefreshSalesProposalFiles = (value) => ({
  type: "SET_REFRESH_SALESPROPOSAL_FILES",
  payload: value
});

export const resetSalesProposalState = () => ({
  type: "RESET_SALESPROPOSAL_STATE"
});

export const mainSalesProposalStatusTab = (tab) => ({
  type: "SET_MAIN_STATUS_TAB",
  payload: tab
});